import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import LinkBlock from '../LinkBlock';

const QuickSearchHits = ({
  suggestions,
  searchUrl,
  site,
  defaultQuickSearch,
  showSearchHitsHeadingSuffix,
}) => {
  if (
    !Array.isArray(suggestions.Hits?.SearchHits) ||
    suggestions.Hits?.SearchHits.length === 0
  ) {
    return null;
  }

  return defaultQuickSearch?.QuickSearchSettingEnabled && site == '1177' ? (
    <div
      className="c-search__quicksearch"
      aria-expanded={suggestions.isVisible}
    >
      <div className="c-search__quicksearch__search-hits__heading">
        <h3
          className="c-search__quicksearch__search-hits__label"
          aria-hidden="true"
        >
          {defaultQuickSearch.QuickSearchSettingHeading || ''}{' '}
        </h3>
        <span
          className="c-search__quicksearch__search-hits__total-hits"
          aria-live="polite"
          aria-label={`${defaultQuickSearch.QuickSearchSettingHeading} ${
            suggestions.Hits?.TotalNumberOfHits
          } sökträffar på ${suggestions?.value?.trim()}.`}
        >
          ({suggestions.Hits?.TotalNumberOfHits} sökträffar)
        </span>
      </div>
      <ul className="c-search__quicksearch__search-hits">
        {suggestions.Hits?.SearchHits.slice(0, 5).map((item, index) => {
          return (
            <li key={index}>
              <a href={item.Url}>{item.Heading}</a>
            </li>
          );
        })}
      </ul>
      <a
        href={encodeURI(`${searchUrl}?q=${suggestions.value}`)}
        className="c-search__quicksearch__search-hits__show-results"
      >
        {suggestions.Hits.ButtonText}
      </a>
    </div>
  ) : (
    site !== '1177' && (
      <>
        <div className="c-search__quicksearch__search-hits__heading">
          <h3 className="c-search__quicksearch__search-hits__label">
            {suggestions.Hits?.SearchHitsHeading || ''}{' '}
            {showSearchHitsHeadingSuffix && suggestions.Hits?.SearchHitsSuffix}
          </h3>
        </div>
        <ul className="c-search__quicksearch__search-hits">
          {suggestions.Hits?.SearchHits.map((term, index) => {
            const quickSearchClasses = classNames({
              'c-search__quicksearch__search-hits__information-type': true,
              'c-search__quicksearch__search-hits__information-type--1001':
                term.InformationType?.Key === '1001',
              'c-search__quicksearch__search-hits__information-type--1002':
                term.InformationType?.Key === '1002',
              'c-search__quicksearch__search-hits__information-type--1003':
                term.InformationType?.Key === '1003',
              'c-search__quicksearch__search-hits__information-type--1004':
                term.InformationType?.Key === '1004',
            });

            const linkBlockItem = {
              Text: term.Heading,
              FriendlyTargetUrl: term.Url,
            };
            <LinkBlock {...linkBlockItem} />;

            return (
              <li key={index}>
                <a
                  className="c-search__quicksearch__search-hits__item"
                  href={term.Url}
                >
                  <span className="c-search__quicksearch__search-hits__heading">
                    {term.Heading}
                  </span>
                  {term.InformationType?.Key !== 'article' && (
                    <span className={quickSearchClasses}>
                      {term.InformationType?.Value || ''}
                    </span>
                  )}
                </a>

                {term.SelectionCode &&
                  term.SelectionCode !== 'none' &&
                  (term.PrimaryCareUrl || term.SpecializedCareUrl) && (
                    <span className="c-search__quicksearch__search-hits__selection-code">
                      {term.PrimaryCareUrl && term.SpecializedCareUrl ? (
                        <>
                          <a
                            className="c-search__quicksearch__search-hits__selection-code-url"
                            href={term.PrimaryCareUrl}
                          >
                            Primärvård
                          </a>{' '}
                          <a
                            className="c-search__quicksearch__search-hits__selection-code-url"
                            href={term.SpecializedCareUrl}
                          >
                            Specialiserad vård
                          </a>
                        </>
                      ) : term.PrimaryCareUrl ? (
                        <a href={term.PrimaryCareUrl}>Primärvård</a>
                      ) : (
                        <a href={term.SpecializedCareUrl}>Specialiserad vård</a>
                      )}
                    </span>
                  )}
              </li>
            );
          })}
        </ul>
        <a
          href={encodeURI(`${searchUrl}?q=${suggestions.value}`)}
          className="c-search__quicksearch__search-hits__show-results"
        >
          {suggestions.Hits.ButtonText}
        </a>
      </>
    )
  );
};

QuickSearchHits.propTypes = {
  hits: PropTypes.arrayOf(
    PropTypes.shape({
      Heading: PropTypes.string,
      Url: PropTypes.string,
      InformationType: PropTypes.shape({
        Key: PropTypes.string,
        Value: PropTypes.string,
      }),
      SelectionCode: PropTypes.string,
      PrimaryCareUrl: PropTypes.string,
      SpecializedCareUrl: PropTypes.string,
    })
  ),
};

export default QuickSearchHits;
